import { render } from "./AdminComponentCharges.vue?vue&type=template&id=c9587f66"
import script from "./AdminComponentCharges.vue?vue&type=script&lang=js"
export * from "./AdminComponentCharges.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__